<div class="modal-notificacao">

    <app-modal-header 
        [svgIcon]="_notificacao.categoria.icon"
        [title]="_notificacao.titulo"
        (closeEmitter)="dialogRef.close()"
    ></app-modal-header>

    <p>{{_notificacao.descricao.texto}}</p>

    @if (_notificacao.descricao?.link) {
        <div class="modal-notificacao-actions d-flex justify-content-end">
            <button mat-button (click)="handleOpenLink()">Acessar link</button>
        </div>
    }

</div>